import {doc} from '../docs.js';
import {joinSegments, contour, triangulate} from 'components/contour/triangulate.js';
import {rasterize} from "components/contour/raster.js";
import ZCanvas from "zobject/custom/ZCanvas.js";

doc(
    "canvas",
    {},
    "Javascript canvas for 2D drawing",
    () => 0,
    { 
        tags: "Graphics"
    }
);

export const canvas = (object) => {
    let zcanvas = new ZCanvas(object);
    object.effect = zcanvas;
    object.width = 300;
    object.height = 300;

    return () => {
    };
};

doc(
    "coords",
    {
    },
    "Creates a coord object from arguments (x,y)",
    undefined,
    {
        inlets: 2,
        isHot: true,
    }
)

export const coords = (object, y) => {
    return (msg) => {
        return {x: msg[0], y: y()};
    };
};

doc(
    "rasterTriangle",
    {
    },
    "Returns a list of coordinates representing the raster points",
    undefined,
    {
        inlets: 4,
        isHot: true,
    });

export const rasterTriangle = (object, b, c, step) => {
    return (msg) => {
        let a = msg[0];
        if (a && b() && c() && step()) {
            let pts = rasterize([a,b(),c()], Math.max(5, step()));
            return [pts];
        }
    };
};

doc(
    "rasterTriangles",
    {
    },
    "Returns a list of coordinates representing the raster points",
    undefined,
    {
        inlets: 2,
        isHot: true
    });

export const rasterTriangles = (object, step) => {
    return (msg) => {
        let _step = step() || 4;
        let a = msg[0];
        if (a && _step) {
            let pts = [];
            for (let i=0 ; i < a.length; i+=6) {
                let tri = a.slice(i, i+6);
                let r = rasterize(tri, Math.max(1, _step));
                r.forEach(pt => pts.push(pt));
            }
            return [pts];
        }
    };
};



doc(
    "triangulate",
    {
    },
    "Returns a list of triangles for a set of points",
    undefined,
    {
        inlets: 2,
        isHot: true
    });

export const _triangulate = (object, step) => {
    return (msg) => {
        let pts = msg[0];
        if (pts && step()) {
            return [triangulate(pts, step())];
        }
    };
};
    

doc(
    "drawArray",
    {
        size: ""
    },
    "Returns a list of coordinates representing the raster points",
    undefined,
    {
        inlets: 3
    }
    );

export const drawArray = (object, size, color) => {
    return (msg) => {
        let a = msg[0];
        let _size = size() || 2;
        let _color = color() || "#ffffff";
        let list = [];
        object.sendMessage(
            object.outputByNumber(0),
            'drawArray', _size, _color, a);
        return undefined;
    };
};

doc(
    "drawTriangles",
    {
    },
    "Returns a list of coordinates representing the raster points",
    undefined,
    {
        inlets: 2
    }
    );

export const drawTriangles = (object, color) => {
    return (msg) => {
        let a = msg[0];
        let _color = color() || "#ffffff";
        let list = [];
        object.sendMessage(
            object.outputByNumber(0),
            'drawTriangles', _color, a);
        return undefined;
    };
};


doc(
    "triangle",
    {
    },
    "Send draw triangle operation to canvas with the 3 inputed coords",
    undefined,
    {
        isHot: true,
        inlets: 4,
    });

export const triangle = (object, b, c, color) => {
    return (msg) => {
        let _a = msg[0];
        let _b = b();
        let _c = c();

        if (_a && _b && _c) {
            object.sendMessage(
                object.outputByNumber(0),
                `triangle ${_a.x} ${_a.y} ${_b.x} ${_b.y} ${_c.x} ${_c.y}`);
            object.sendMessage(
                object.outputByNumber(0),
                `fill ${color()}`);
        }
        return undefined;
    };
};
 

